import React from 'react';
import { Inbox } from 'lucide-react';
import { Button } from './Button';
import './States.css';

/**
 * EmptyState — «пусто» после УСПЕШНОГО пустого ответа. Пока грузится —
 * LoadingState, если упало — ErrorState (или всё сразу — LoadState).
 *
 *   icon        — иконка lucide (по умолчанию Inbox); icon={null} — без иконки
 *   title       — что пусто: «Отгрузок нет», «Ничего не найдено»
 *   description — что сделать: «Сбросьте фильтры или создайте отгрузку»
 *   action      — { label, onClick, icon?, variant? } или готовый элемент
 *   compact     — строкой внутри таблицы/карточки
 */
export function EmptyState({ icon = Inbox, title = 'Ничего нет', description, action, compact = false, className = '' }) {
  const Icon = icon;
  return (
    <div className={`ui-empty ${compact ? 'ui-empty--compact' : ''} ${className}`}>
      {Icon && !compact && <Icon size={40} className="ui-empty__icon" aria-hidden="true" />}
      {title && <p className="ui-empty__title">{title}</p>}
      {description && <p className="ui-empty__desc">{description}</p>}
      {action && (React.isValidElement(action) ? (
        <div className="ui-empty__action">{action}</div>
      ) : (
        <Button variant={action.variant || 'secondary'} size="sm" className="ui-empty__action" {...action}>
          {action.label}
        </Button>
      ))}
    </div>
  );
}
